var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/cost"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M15.88 3.13H7.88C5.12 3.13 2.88 5.37 2.88 8.13V16.13C2.88 18.89 5.12 21.13 7.88 21.13H15.88C18.64 21.13 20.88 18.89 20.88 16.13V8.13C20.88 5.37 18.64 3.13 15.88 3.13ZM12.78 16.16L12.62 16.2V17.32H10.85V16.17L10.7 16.13C9.39 15.75 9.1 14.63 9.04 13.74C9.4 13.66 10.23 13.48 10.67 13.38C10.75 13.84 10.98 14.6 11.81 14.6C12.34 14.6 12.6 14.4 12.72 14.23C12.85 14.06 12.9 13.84 12.85 13.65C12.74 13.15 12.16 12.95 11.49 12.72C10.44 12.36 9.25001 11.95 9.22001 10.33C9.22001 10.14 9.19001 8.55 10.81 8.1L10.96 8.06V6.94H12.72V8.08L12.88 8.12C14.22 8.51 14.5 9.64 14.53 10.38L12.92 10.77C12.82 10.02 12.44 9.64 11.79 9.64C11.47 9.64 11.23 9.76 11.09 9.95C10.97 10.11 10.93 10.3 10.98 10.48C11.08 10.93 11.65 11.14 12.31 11.38C13.38 11.77 14.7 12.26 14.73 13.91C14.73 13.93 14.72 15.7 12.8 16.15L12.78 16.16Z",
    fill: "#0C0C0C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCost);
export default __webpack_public_path__ + "static/media/cost.3b9595782e584698a8cf2aa718987d50.svg";
export { ForwardRef as ReactComponent };